// Translation for fr
export const fr = {
        common: {
            save: 'Enregistrer',
            cancel: 'Annuler',
            close: 'Fermer',
            delete: 'Supprimer',
            edit: 'Modifier',
            activate: 'Activer',
            add: 'Ajouter',
            saving: 'Enregistrement...',
            loading: 'Chargement...',
            active: 'ACTIF',
            inUse: 'En cours d\'utilisation',
            test: 'Test',
            searchApps: 'Rechercher des applications...',
            betaBanner: 'BETA - Service non disponible pour le moment !'
        },
        header: {
            creditBalance: 'Solde',
            minutes: 'MIN'
        },
        auth: {
            signIn: 'Se connecter',
            signUp: 'S\'inscrire',
            username: 'Nom d\'utilisateur',
            password: 'Mot de passe',
            continue: 'Continuer',
            noAccount: 'Pas encore de compte ?',
            hasAccount: 'Vous avez déjà un compte ?',
            loginError: 'Échec de la connexion',
            invalidCredentials: 'Nom d\'utilisateur ou mot de passe invalide',
            rateLimited: 'Trop de tentatives de connexion. Veuillez patienter un moment.',
            sessionExpired: 'Votre session a expiré. Veuillez utiliser un nouveau lien magique.',
            magicLinkInvalid: 'Le lien de connexion est invalide ou a expiré.',
            magicLinkSuccess: 'Bienvenue ! Vous avez été connecté avec succès.',
            magicLinkProcessing: 'Traitement de la connexion...',
            connectionError: 'Erreur de connexion. Veuillez réessayer.'
        },
        profile: {
            myProgress: 'Mon Progrès d\'Apprentissage',
            signOut: 'Se Déconnecter',
            plan: 'Plan : '
        },
        settings: {
            title: 'Paramètres',
            tabs: {
                uiSettings: 'Paramètres UI',
                systemPrompt: 'Invite Système',
                llmProfiles: 'Profils LLM',
                ttsProfiles: 'Profils TTS',
                language: 'Langue',
            },
            uiSettings: {
                title: 'Interface Utilisateur',
                themeMode: 'Mode Thème',
                darkMode: 'Mode Sombre',
                lightMode: 'Mode Clair',
                themeColor: 'Couleur du Thème',
                themeColorDesc: 'Choisissez la couleur d\'accentuation pour les boutons, icônes et surbrillances',
                background: 'Arrière-plan',
                backgroundDesc: 'Choisissez un arrière-plan pour votre espace de travail',
                selectBackgroundColor: 'Choisir la couleur d\'arrière-plan',
                backgrounds: {
                    cyberSchooling: 'Cyber Schooling',
                    focus: 'Concentration',
                    concentration: 'Concentration Profonde',
                    relaxation: 'Relaxation',
                    lianas: 'Lianes',
                    color: 'Couleur'
                },
                backgroundColors: {
                    deepDark: 'Noir Profond',
                    darkGrey: 'Gris Foncé',
                    midnightBlue: 'Bleu Minuit',
                    indigo: 'Indigo',
                    darkTeal: 'Sarcelle Foncé',
                    brown: 'Marron',
                    darkRed: 'Rouge Foncé',
                    deepPurple: 'Violet Profond',
                    pureWhite: 'Blanc Pur',
                    softWhite: 'Blanc Doux',
                    lightGrey: 'Gris Clair',
                    paleBlue: 'Bleu Pâle',
                    paleGreen: 'Vert Pâle',
                    paleOrange: 'Orange Pâle',
                    lavender: 'Lavande',
                    blueGrey: 'Gris Bleu'
                }
            },
            systemPrompt: {
                label: 'Invite Système:',
                placeholder: 'Chargement de l\'invite système...',
                emptyError: 'L\'invite système ne peut pas être vide!',
                saveSuccess: '✓ Invite système enregistrée avec succès!',
                loadError: 'Erreur lors du chargement de l\'invite système',
                saveError: 'Erreur lors de l\'enregistrement'
            },
            llmProfiles: {
                addButton: '+ Ajouter une Nouvelle Connexion',
                newConnection: 'Nouvelle Connexion',
                editConnection: 'Modifier la Connexion',
                emptyState: 'Aucune connexion LLM disponible. Cliquez ci-dessous pour en ajouter une.',
                loadingProfiles: 'Chargement des profils...',
                nameLabel: 'Nom *',
                namePlaceholder: 'par ex. OpenAI GPT-4',
                apiUrlLabel: 'URL API *',
                apiUrlPlaceholder: 'https://api.openai.com/v1/chat/completions',
                apiKeyLabel: 'Clé API *',
                apiKeyPlaceholder: 'sk-...',
                modelLabel: 'Modèle *',
                modelPlaceholder: 'gpt-4, mistral-tiny, etc.',
                allFieldsRequired: 'Tous les champs doivent être remplis!',
                saveSuccess: '✓ Profil enregistré avec succès!',
                deleteConfirm: 'Voulez-vous vraiment supprimer "{name}"?',
                profileNotFound: 'Profil non trouvé!',
                loadError: 'Erreur lors du chargement des profils',
                saveError: 'Erreur lors de l\'enregistrement',
                activateError: 'Erreur lors de l\'activation',
                deleteError: 'Erreur lors de la suppression',
                modelInfo: 'Modèle: {model} | API: {api}'
            },
            ttsProfiles: {
                addButton: '+ Ajouter une Nouvelle Voix',
                newVoice: 'Nouvelle Voix',
                editVoice: 'Modifier la Voix',
                emptyState: 'Aucun profil TTS disponible. Cliquez ci-dessous pour en ajouter un.',
                loadingProfiles: 'Chargement des profils TTS...',
                nameLabel: 'Nom',
                namePlaceholder: 'par ex. Mon ElevenLabs Adam',
                providerLabel: 'Fournisseur',
                providerPlaceholder: 'par ex. ElevenLabs, OpenAI, Piper',
                providerPiper: 'Piper (Local)',
                providerOpenAI: 'OpenAI',
                providerElevenLabs: 'ElevenLabs',
                providerAzure: 'Azure',
                apiUrlLabel: 'URL API *',
                apiUrlPlaceholder: 'https://api.example.com/tts',
                apiKeyLabel: 'Clé API *',
                apiKeyPlaceholder: 'sk-...',
                modelIdLabel: 'ID Modèle *',
                modelIdPlaceholder: 'par ex. eleven_monolingual_v1',
                voiceIdLabel: 'ID Voix',
                voiceIdPlaceholder: 'par ex. pNInz6obpgDQGcFmaJgB',
                allFieldsRequired: 'Tous les champs doivent être remplis!',
                saveSuccess: '✓ Profil TTS enregistré avec succès!',
                deleteConfirm: 'Voulez-vous vraiment supprimer "{name}"?',
                loadError: 'Erreur lors du chargement des profils TTS',
                saveError: 'Erreur lors de l\'enregistrement',
                activateError: 'Erreur lors de l\'activation',
                deleteError: 'Erreur lors de la suppression'
            },
            language: {
                title: 'Choisir la Langue',
                description: 'Sélectionnez votre langue préférée pour l\'interface utilisateur'
            },
        },
        chat: {
            ready: 'Prêt',
            start: 'DÉMARRER',
            stop: 'ARRÊTER',
            initialMessage: 'Cliquez sur DÉMARRER pour une conversation en temps réel.',
            listening: 'Écoute...',
            speaking: 'Thorsten parle...',
            userLabel: 'Vous',
            aiLabel: 'IA',
            modalTitle: 'Thorsten AI Chat',
            inputPlaceholder: 'Écrivez un message...',
            send: 'Envoyer',
            loginRequired: 'Veuillez vous connecter pour utiliser ce service.',
            loginButton: 'Se connecter maintenant',
            magicLinkRequired: 'Veuillez utiliser un lien magique pour vous connecter.',
            creditLimitError: 'Votre quota horaire est épuisé. Veuillez mettre à niveau votre plan (Medium/Premium) pour continuer.',
            serviceDisabled: 'Le service de chat est actuellement indisponible. Veuillez réessayer plus tard.'
        },
        notifications: {
            error: 'Erreur',
            success: 'Succès',
            info: 'Information',
            unknownError: 'Une erreur inconnue s\'est produite'
        },
        cookie: {
            message: 'Ce site Web utilise des cookies pour vous offrir la meilleure expérience utilisateur possible.',
            accept: 'Accepter'
        },
        curriculum: {
                buttonLabel: 'Curriculum',
                buttonTitle: 'Afficher le contenu du curriculum',
                modalTitle: 'Curriculum {app}',
                sections: {
                    topic: 'Sujet du curriculum',
                    explanation: 'Explication adaptée aux enfants',
                    chat: 'Poser une question à l\'IA',
                    studentProfile: 'Profil de l\'élève'
                },
                chat: {
                    hint: 'Pose une question sur ce sujet du curriculum. L\'IA t\'aide à comprendre pourquoi c\'est important.',
                    placeholder: 'Écris ta question …',
                    inputAria: 'Question pour l\'IA',
                    send: 'Envoyer',
                    sending: 'Envoi …',
                    empty: 'L\'IA n\'a pas renvoyé de réponse. Réessaie, s\'il te plaît.',
                    noTopic: 'Aucun contenu de curriculum n\'est disponible pour poser des questions.',
                    requestFailed: 'Impossible de générer une réponse.'
                },
                topic: {
                    empty: 'Aucun sujet de curriculum n\'est lié à cette micro-application dans le backend.',
                    missingDetail: 'Les données détaillées du curriculum pour cette micro-application ne sont pas encore disponibles dans le backend.',
                    learningGoals: 'Objectifs d\'apprentissage',
                    prerequisites: 'Prérequis',
                    unitLabel: 'Unité',
                    durationLabel: 'Durée',
                    difficultyLabel: 'Difficulté',
                    hours: 'h',
                    minutes: 'min'
                },
                explanation: {
                    empty: 'Aucune explication adaptée aux enfants disponible.',
                    loadingPrepare: 'L\'IA prépare l\'explication',
                    loadingExplain: 'L\'IA explique le sujet dans un langage adapté aux enfants',
                    requestFailed: 'L\'explication adaptée aux enfants n\'a pas pu être générée.'
                },
                studentProfile: {
                    country: 'Pays',
                    region: 'État / Région',
                    schoolType: 'Type d\'école',
                    grade: 'Classe',
                    noContext: 'Aucun contexte élève disponible.',
                    childProfileNotFound: 'Aucun profil d\'élève trouvé dans le backend pour la connexion actuelle.',
                    loginProfileIncomplete: 'Le profil de connexion ne contient pas encore un contexte élève complet.',
                    educationContextNotFound: 'Un profil d\'élève a été trouvé, mais aucune affectation de curriculum n\'est définie.',
                    noToken: 'Aucun élève connecté trouvé.'
                },
                errors: {
                    signInRequired: 'Veuillez vous connecter pour voir le curriculum.',
                    appIdMissing: 'L\'ID de l\'application est manquant.',
                    loadFailed: 'Impossible de charger les données du curriculum.'
                }
            }
    };
